import {
  SmileOutlined,
  OrderedListOutlined,
  ClockCircleOutlined,
  FileOutlined,
  NotificationOutlined,
  LeftOutlined,
} from "@ant-design/icons";
import { Button, Row, Typography } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { newBookingRequest } from "services/SauceService";
import { useState } from "react";
import dayjs from "dayjs";
import "./BookCollab.scss";
import DrawerInstructions from "./DrawerInstructions";

const items = [
  {
    icon: <SmileOutlined style={{ color: "#3BB76D", fontSize: 18 }} />,
    text: <>Be your genuine self</>,
  },
  {
    icon: <OrderedListOutlined style={{ color: "#FFA723", fontSize: 18 }} />,
    text: (
      <>
        Follow{" "}
        <span
          style={{
            color: "#158AFF",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          Instructions
        </span>
      </>
    ),
    event: "instructions",
  },
  {
    icon: <ClockCircleOutlined style={{ color: "#FFA723", fontSize: 18 }} />,
    text: (
      <>
        Show up{" "}
        <span
          style={{
            color: "#158AFF",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          on time
        </span>{" "}
        for your collaboration
      </>
    ),
    event: "policy",
  },
  {
    icon: <FileOutlined style={{ color: "#FFA723", fontSize: 18 }} />,
    text: (
      <>
        Submit content{" "}
        <span
          style={{
            color: "#158AFF",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          within 5 days
        </span>{" "}
        after visit
      </>
    ),
    event: "policy",
  },
  {
    icon: <NotificationOutlined style={{ color: "#FFA723", fontSize: 18 }} />,
    text: (
      <>
        Allow content to be used for{" "}
        <span
        // style={{
        //   color: "#158AFF",
        //   textDecoration: "underline",
        //   cursor: "pointer",
        // }}
        >
          re-marketing
        </span>
      </>
    ),
    // event: "remarketing",
  },
];

const deliverablesObjectToArray = (deliverables: any) => {
  let deliverablesArray: any = [];
  if (deliverables?.instagramReel) {
    deliverablesArray.push("Instagram Reel");
  }
  if (deliverables?.instagramStory) {
    deliverablesArray.push("Instagram Story");
  }
  if (deliverables?.tiktokVideo) {
    deliverablesArray.push("TikTok Video");
  }
  return deliverablesArray;
};
const BookCollabConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const {
    collab,
    spotId,
    previousBooking,
  }: { collab?: any; spotId?: any; previousBooking?: any } = state || {};
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const previousBookingId = previousBooking?.bookingId;
  // const selectedDate = state?.selectedDate?.format
  //   ? state.selectedDate.format("dddd, MMM DD, ")
  //   : "";

  const onClickRequest = async () => {
    const params = {
      collabId: collab?.collabId,
      preferredDates: state?.selectedSlots.map((slot: any) => ({
        date: slot?.date?.format(),
        hour: slot.time,
      })),
      compensation: {
        deliverables: deliverablesObjectToArray(state?.collab?.deliverables),
        spotId,
      },
      previousBookingId,
      deliveryAddress: state?.deliveryAddress,
      deliveryAddressPlaceId: state?.deliveryAddressPlaceId,
      deliveryAddressComplement: state?.deliveryAddressComplement,
    };
    try {
      setLoading(true);
      const response = await newBookingRequest(params);
      console.log(response);
      if (response) navigate("/book/collab-success", { state });
    } catch {
      navigate("/book/collab-failed", { state });
    } finally {
      setLoading(false);
    }

    // const path = randomBoolean ? "/book/collab-success" : "/book/collab-failed";
    // navigate(path, { state });
  };

  const onClickHighlighted = (event: string | undefined) => {
    switch (event) {
      case "instructions":
        setOpen(true);
        break;
      case "policy":
        window.open(
          "https://www.mustard.love/reschedule-and-cancellation-policy",
          "_blank"
        );

        break;
      case "remarketing":
        window.open("https://www.mustard.love/remarketing-policy", "_blank");
        break;
      default:
        break;
    }
  };

  return (
    <div className="book-confirmation" style={{ overflow: "auto" }}>
      <div>
        <Row
          justify="space-between"
          style={{ alignItems: "center", marginTop: 20 }}
        >
          <LeftOutlined
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
        </Row>
        <Typography.Title
          level={3}
          style={{ margin: "36px 0 16px 0", textAlign: "start" }}
          className="heading-3-22-semi-bold"
        >
          {previousBooking ? "Request Reshedule?" : "Confirm application"}
        </Typography.Title>
        <Typography.Title
          level={5}
          style={{ margin: 0 }}
          className="subtitle-18-semi-bold-poppins"
        >
          {state?.collab?.venue?.name}
        </Typography.Title>
        <Typography.Text style={{ margin: 0 }}>
          {previousBooking && <b>New proposed time:</b>}
          {state?.selectedSlots.map((slot: any) => (
            <span
              style={{ display: "block" }}
              className="subtitle-18-regular-poppins"
            >
              {`${slot?.date?.format("dddd, MMM DD, ")} ${slot.time}`}
              {/* {TODO ERROR} */}
            </span>
          ))}
        </Typography.Text>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <h3>By applying you agree to:</h3>
        </div>
        <div
          style={{
            background: "#fff",
            borderRadius: 20,
            padding: "28px 30px",
            margin: 24,
            border: "1.5px solid #ffe1a7",
          }}
        >
          <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
            {items.map((item, idx) => (
              <li
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: idx === items.length - 1 ? 0 : 18,
                }}
              >
                <span style={{ marginRight: 18 }}>{item.icon}</span>
                <span
                  className="body-16-regular-poppins"
                  onClick={() => onClickHighlighted(item.event)}
                  style={{ cursor: "pointer" }}
                >
                  {item.text}
                </span>
              </li>
            ))}
          </ul>
        </div>
        {previousBooking ? (
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Typography.Title level={5} style={{ margin: 0 }}>
              Attention!
            </Typography.Title>
            <Typography.Text>
              Your previous booking for{" "}
              <b>
                {`${dayjs(previousBooking?.applicationDate?.date)?.format(
                  "dddd, MMM DD, "
                )} ${previousBooking?.applicationDate?.hour}`}{" "}
                will be canceled
              </b>
              . The venue will review this application as if it was a new one.
            </Typography.Text>
          </div>
        ) : (
          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Typography.Text className="body-16-regular">
              Apply early to boost your chances. Not all applications will be
              approved.
            </Typography.Text>
          </div>
        )}
      </div>
      <div style={{ width: "100%", display: "flex" }}>
        {previousBooking ? (
          <Button
            type="primary"
            onClick={onClickRequest}
            loading={loading}
            style={{ flex: 1 }}
          >
            Send request
          </Button>
        ) : (
          <Button
            type="primary"
            onClick={onClickRequest}
            loading={loading}
            style={{ flex: 1 }}
          >
            Apply now
          </Button>
        )}
      </div>

      <DrawerInstructions open={open} setOpen={setOpen} collab={collab} />
    </div>
  );
};

export default BookCollabConfirmation;
